Object.defineProperty(exports,"__esModule",{value:true});exports.sortFixturesByStatesCounter=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=




sortFixturesByState;var _helper=require('./helper');var _stateCounters=require('../counters/stateCounters');function sortFixturesByState(fixtures){
return(
fixtures.

map(function(f){
var counts=(0,_stateCounters.summary)(f);
return _extends({
fixture:f},
counts);

}).


sort(function(f1,f2){
if(f1.red===f2.red){
if(f1.yellow===f2.yellow){
return f2.ok-f1.ok;
}

return f2.yellow-f1.yellow;
}

return f2.red-f1.red;
}).

map(function(obj){return obj.fixture;}));

}

var sortFixturesByStatesCounter=exports.sortFixturesByStatesCounter=function sortFixturesByStatesCounter(fixtures){
if(!fixtures||fixtures.length<=0)return fixtures;

return fixtures.sort(function(fixture1,fixture2){

if(fixture1.statesCounter.alarming===fixture2.statesCounter.alarming){
if(fixture1.statesCounter.disarmed===fixture2.statesCounter.disarmed){
if(
fixture1.statesCounter.unlocked===fixture2.statesCounter.unlocked)
{

if(
fixture1.statesCounter.unhealthy===
fixture2.statesCounter.unhealthy)
{



if(
fixture1.statesCounter.nonCompliant===
fixture2.statesCounter.nonCompliant)
{
if(
fixture1.statesCounter.armed===fixture2.statesCounter.armed)
{
if(
fixture1.statesCounter.locked===
fixture2.statesCounter.locked)
{
if(
fixture1.statesCounter.healthy===
fixture2.statesCounter.healthy)
{
return(
fixture2.statesCounter.compliant-
fixture1.statesCounter.compliant);

}
return(
fixture2.statesCounter.healthy-
fixture1.statesCounter.healthy);

}
return(
fixture2.statesCounter.locked-fixture1.statesCounter.locked);

}
return fixture2.statesCounter.armed-fixture1.statesCounter.armed;
}
return(
fixture2.statesCounter.nonCompliant-
fixture1.statesCounter.nonCompliant);

}
return(
fixture2.statesCounter.unhealthy-fixture1.statesCounter.unhealthy);

}
return fixture2.statesCounter.unlocked-fixture1.statesCounter.unlocked;
}
return fixture2.statesCounter.disarmed-fixture1.statesCounter.disarmed;
}
return fixture2.statesCounter.alarming-fixture1.statesCounter.alarming;
});
};